/*
 * Loading components for Elementor admin panel`    `
 */

import {ClimaKrete} from "./components/ClimaKrete";
import {loadComponents} from "./functions/helpers";

(function($){
    // Initialize each block on page load (front end).
    $(document).ready(function(){
        if (window.elementorFrontend && elementorFrontend.hooks) {
            // When a specific widget renders
            elementorFrontend.hooks.addAction('frontend/element_ready/climakrete-calculator.default', ($scope) => {
                loadComponents({ClimaKrete});
            });

            // Also catch general document ready inside the editor iframe
            elementorFrontend.on('components:init', () => loadComponents({ClimaKrete}));
        }
    });
})(jQuery);
